__turbopack_context__.v({
  "action": "_9Ax8Ba_action",
  "actionSlot": "_9Ax8Ba_actionSlot",
  "bottom-center": "_9Ax8Ba_bottom-center",
  "bottom-left": "_9Ax8Ba_bottom-left",
  "bottom-right": "_9Ax8Ba_bottom-right",
  "card": "_9Ax8Ba_card",
  "close": "_9Ax8Ba_close",
  "contained": "_9Ax8Ba_contained",
  "content": "_9Ax8Ba_content",
  "copy": "_9Ax8Ba_copy",
  "description": "_9Ax8Ba_description",
  "glyph": "_9Ax8Ba_glyph",
  "icon": "_9Ax8Ba_icon",
  "item": "_9Ax8Ba_item",
  "line": "_9Ax8Ba_line",
  "list": "_9Ax8Ba_list",
  "spin": "_9Ax8Ba_spin",
  "spinner": "_9Ax8Ba_spinner",
  "srOnly": "_9Ax8Ba_srOnly",
  "title": "_9Ax8Ba_title",
  "viewport": "_9Ax8Ba_viewport",
});
